import { z } from "zod";
import { putProfileResolverSchema } from "../schemas/put-profile.schema";

const putProfileValidateSchema = putProfileResolverSchema();

export type PutProfileRequest = z.infer<typeof putProfileValidateSchema>;
